"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusGetter = statusGetter;
const utils_1 = require("@daytrip/utils");
function statusGetter(self, selfConstructor, statusConstructor) {
    for (const key in statusConstructor) {
        // go thru all statuses
        // seems to rely on implementation details of enum 🤦‍♂️
        if (isNaN(Number(key))) {
            // get how this status should look like
            const statusPrototype = selfConstructor.statusPrototype(statusConstructor[key]);
            // check if the status props are equal
            let isEqual = true;
            for (const k in statusPrototype) {
                if (isEqual && (0, utils_1.isUndefinedOrNull)(self[k]) !== (0, utils_1.isUndefinedOrNull)(statusPrototype[k])) {
                    isEqual = false;
                    break;
                }
            }
            if (isEqual) {
                return statusConstructor[key];
            }
        }
    }
    throw new Error("status was not recognized");
}
//# sourceMappingURL=statusGetter.js.map